import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const ActionButton = styled(IconButton)(({ color1, color2 }) => ({
  background: `linear-gradient(135deg, ${color1}22 0%, ${color2}22 100%)`,
  color: color2,
  margin: "0 0.2em",
  borderRadius: 8, // Square with slight rounding
  boxShadow: "0 4px 18px 0 rgba(60, 72, 100, 0.13)", // Attractive shadow
  transition: "all 0.18s cubic-bezier(.4,2,.6,1)",
  "&:hover": {
    filter: "brightness(1.1)",
    transform: "scale(1.12)",
    background: `linear-gradient(135deg, ${color1}44 0%, ${color2}44 100%)`,
    boxShadow: "0 8px 28px 0 rgba(60, 72, 100, 0.18)", // Stronger shadow on hover
  },
  fontSize: 16, // smaller icon
  padding: 4,   // smaller padding
}));

export default ActionButton;
